var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shop" }, [
    _c("h2", [_vm._v("店铺信息")]),
    _vm._v(" "),
    _c("div", { staticClass: "normal" }, [
      _vm._v("店铺名称：\n    "),
      _c(
        "div",
        { staticClass: "inputBox" },
        [
          _c("el-input", {
            model: {
              value: _vm.name,
              callback: function($$v) {
                _vm.name = $$v
              },
              expression: "name"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "normal" },
      [
        _vm._v("所属平台：\n    "),
        _c(
          "el-select",
          {
            attrs: {
              filterable: "",
              placeholder: "选择平台",
              "default-first-option": ""
            },
            model: {
              value: _vm.platform,
              callback: function($$v) {
                _vm.platform = $$v
              },
              expression: "platform"
            }
          },
          _vm._l(_vm.pList, function(item) {
            return _c("el-option", {
              key: item,
              attrs: { label: item, value: item }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.upToDb } },
          [_vm._v("上传")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b6a8fe6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b6a8fe6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Shop.vue
// module id = null
// module chunks = 